export enum ConversationTaskType {
  OutboundCallOnBehalf = 'OutboundCallOnBehalf',
  OutboundService = 'OutboundService',
  OutboundCallWithWorkflow = 'OutboundCallWithWorkflow',
  Incoming = 'Incoming',
  ExternalTask = 'ExternalTask',
  InboundEmail = 'InboundEmail',
  ConsultationCallWithWorkflow = 'ConsultationCallWithWorkflow',
}
